import axios from 'axios'
import interceptors from './interceptors'
import { Loading } from 'element-ui'

class RequestInstance {
  /** 实例配置 */
    config = {
      baseURL: process.env.VUE_APP_BASE_API,
      timeout: 60000,
      isLoading: true,
      loading: {
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      }
    }
    /** loading服务 */
    loadingService = null
    /** 请求次数 */
    requestSize = 0
    constructor(config) {
      this.config = Object.assign(this.config, config)
      this.instance = this.createInstance(this.config)
      this.createInterceptors()
    }
    createInstance() {
      return axios.create(this.config)
    }
    createInterceptors() {
      this.instance.interceptors.request.use(
        (config) => {
          this.showLoading()
          return interceptors.requestResolve(config)
        },
        (error) => {
          this.hideLoading()
          return interceptors.requestReject(error)
        })

      this.instance.interceptors.response.use(
        (config) => {
          this.hideLoading()
          return interceptors.responseResolve(config)
        },
        (error) => {
          this.hideLoading()
          return interceptors.responseReject(error)
        })
    }
    createServiceInterceptors() {
      if (this.config.interceptors === undefined) return
      if (this.config.interceptors.request === undefined) return
      if (this.config.interceptors.response === undefined) return
      axios.interceptors.request.use(this.config.interceptors.request)
      axios.interceptors.response.use(this.config.interceptors.response)
    }
    showLoading() {
      if (!this.config.isLoading) return
      this.requestSize++
      this.loadingService = Loading.service(this.config.loading)
    }
    hideLoading() {
      this.requestSize--
      if (this.requestSize <= 0) this.loadingService.close()
    }
    get(url, config) {
      return this.instance.get(url, config)
    }
    post(url, data, config) {
      return this.instance.post(url, data, config)
    }
    patch(url, data, config) {
      return this.instance.patch(url, data, config)
    }
    delete(url, config) {
      return this.instance.delete(url, config)
    }
}

export default RequestInstance
